import { Box, LinearProgress, Stack, styled, useMediaQuery } from '@material-ui/core';
import React from 'react';
import { AppFrameTitle, DRAWER_WIDTH } from './AppFrame';


interface PageProps {
  title: string;
  addPadding?: boolean;
  loading?: boolean;
}

const LoadingContainer = styled('div')({
  height: 4,
});

const AppPage: React.FC<PageProps> = ({ children, title, addPadding = true, loading }) => {
  const isMobile = useMediaQuery('(max-width:600px)');


  return (
    <Stack direction="column" flex={1} sx={{ minHeight: 'calc(100vh - 64px)' }}>
      <LoadingContainer>
        {
          loading ? <LinearProgress color="secondary" /> : null
        }
      </LoadingContainer>
      <Box sx={{ display: 'flex', flexDirection: 'column', flex: 1, p: addPadding ? 2 : 0, maxWidth: isMobile ? '100vw' : `calc(100vw - ${DRAWER_WIDTH}px)` }}>
        <AppFrameTitle title={title} />

        {children}
      </Box>
    </Stack>
  );
}

export default AppPage;